import { createFileRoute } from '@tanstack/react-router';

import { faqSearchSchema } from '@/features/faq/schemas/faq-search.schema';
import { FaqVoloteaPage } from '@/pages/faq-volotea.page';

export const Route = createFileRoute('/$locale/faq/volotea')({
  component: FaqVoloteaPage,
  validateSearch: (search) => faqSearchSchema.parse({ category: search.category }),
});
